import { PaymentOptionDescriptor, PaymentOptions } from '@vitupay-public/vitupay';
export * from '@vitupay-public/vitupay';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';

class VituPayGooglePayElementComponent {
    constructor() {
        this.clickValidator = () => Promise.resolve();
        this.onSubmitEvent = new EventEmitter();
        this.onSuccess = new EventEmitter();
        this.onError = new EventEmitter();
        this.option = PaymentOptionDescriptor.GooglePay;
    }
    ngOnInit() {
        this.buttonId = `VITUPAY_${this.option}_${new Date().getTime()}`;
        this.paymentOptions = PaymentOptions.init([
            {
                descriptor: this.option
            }
        ]);
    }
    ngOnDestroy() {
        this.paymentElement?.remove();
    }
    ngAfterViewInit() {
        this.paymentOptions.add([ /* { descriptor: this.option } */], (paymentElements) => {
            this.paymentElement =
                paymentElements.add(this.option, `#${this.buttonId}`, this.config, (events) => { this.successHandler(events); }, (error) => { this.onError.emit(error); }, this.clickValidator);
        }, (error) => { this.onError.emit(error); });
    }
    successHandler(events) {
        this.onSuccess.emit(events);
        this.events = events;
        this.events.listenSubmit((submitEvent) => {
            this.onSubmitEvent.emit(submitEvent);
        });
    }
}
VituPayGooglePayElementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayGooglePayElementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VituPayGooglePayElementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VituPayGooglePayElementComponent, selector: "vitupay-google-pay-element", inputs: { config: "config", clickValidator: "clickValidator" }, outputs: { onSubmitEvent: "onSubmitEvent", onSuccess: "onSuccess", onError: "onError" }, viewQueries: [{ propertyName: "buttonContainer", first: true, predicate: ["buttonContainer"], descendants: true }], ngImport: i0, template: "<div [id]=\"buttonId\" #buttonContainer>\n    <!-- VituPay Google Pay injected here -->\n</div>\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayGooglePayElementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vitupay-google-pay-element', template: "<div [id]=\"buttonId\" #buttonContainer>\n    <!-- VituPay Google Pay injected here -->\n</div>\n" }]
        }], propDecorators: { config: [{
                type: Input
            }], clickValidator: [{
                type: Input
            }], onSubmitEvent: [{
                type: Output
            }], onSuccess: [{
                type: Output
            }], onError: [{
                type: Output
            }], buttonContainer: [{
                type: ViewChild,
                args: ["buttonContainer"]
            }] } });

class VituPayApplePayElementComponent {
    constructor() {
        this.clickValidator = () => Promise.resolve();
        this.onSubmitEvent = new EventEmitter();
        this.onSuccess = new EventEmitter();
        this.onError = new EventEmitter();
        this.option = PaymentOptionDescriptor.ApplePay;
    }
    ngOnInit() {
        this.buttonId = `VITUPAY_${this.option}_${new Date().getTime()}`;
        this.paymentOptions = PaymentOptions.init([
            {
                descriptor: this.option
            }
        ]);
    }
    ngOnDestroy() {
        this.paymentElement?.remove();
    }
    ngAfterViewInit() {
        this.paymentOptions.add([ /* { descriptor: this.option } */], (paymentElements) => {
            this.paymentElement =
                paymentElements.add(this.option, `#${this.buttonId}`, this.config, (events) => { this.successHandler(events); }, (error) => { this.onError.emit(error); }, this.clickValidator);
        }, (error) => { this.onError.emit(error); });
    }
    successHandler(events) {
        this.onSuccess.emit(events);
        this.events = events;
        this.events.listenSubmit((submitEvent) => {
            this.onSubmitEvent.emit(submitEvent);
        });
    }
}
VituPayApplePayElementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayApplePayElementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VituPayApplePayElementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VituPayApplePayElementComponent, selector: "vitupay-apple-pay-element", inputs: { config: "config", clickValidator: "clickValidator" }, outputs: { onSubmitEvent: "onSubmitEvent", onSuccess: "onSuccess", onError: "onError" }, viewQueries: [{ propertyName: "buttonContainer", first: true, predicate: ["buttonContainer"], descendants: true }], ngImport: i0, template: "<div [id]=\"buttonId\" #buttonContainer>\n    <!-- VituPay Apple Pay injected here -->\n</div>\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayApplePayElementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vitupay-apple-pay-element', template: "<div [id]=\"buttonId\" #buttonContainer>\n    <!-- VituPay Apple Pay injected here -->\n</div>\n" }]
        }], propDecorators: { config: [{
                type: Input
            }], clickValidator: [{
                type: Input
            }], onSubmitEvent: [{
                type: Output
            }], onSuccess: [{
                type: Output
            }], onError: [{
                type: Output
            }], buttonContainer: [{
                type: ViewChild,
                args: ["buttonContainer"]
            }] } });

class VituPayPayPalElementComponent {
    constructor() {
        this.clickValidator = () => Promise.resolve();
        this.onSubmitEvent = new EventEmitter();
        this.onSuccess = new EventEmitter();
        this.onError = new EventEmitter();
        this.option = PaymentOptionDescriptor.PayPal;
    }
    ngOnInit() {
        this.buttonId = `VITUPAY_${this.option}_${new Date().getTime()}`;
        const payPalConfig = this.config;
        const options = {
            isProduction: payPalConfig.isProduction,
            clientId: payPalConfig.clientId
        };
        this.paymentOptions = PaymentOptions.init([
            {
                descriptor: this.option,
                options
            }
        ]);
    }
    ngOnDestroy() {
        this.paymentElement?.remove();
    }
    ngAfterViewInit() {
        this.paymentOptions.add([ /* { descriptor: this.option } */], (paymentElements) => {
            this.paymentElement =
                paymentElements.add(this.option, `#${this.buttonId}`, this.config, (events) => { this.successHandler(events); }, (error) => { this.onError.emit(error); }, this.clickValidator);
        }, (error) => { this.onError.emit(error); });
    }
    successHandler(events) {
        this.onSuccess.emit(events);
        this.events = events;
        this.events.listenSubmit((submitEvent) => {
            this.onSubmitEvent.emit(submitEvent);
        });
    }
}
VituPayPayPalElementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayPayPalElementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VituPayPayPalElementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VituPayPayPalElementComponent, selector: "vitupay-paypal-element", inputs: { config: "config", clickValidator: "clickValidator" }, outputs: { onSubmitEvent: "onSubmitEvent", onSuccess: "onSuccess", onError: "onError" }, viewQueries: [{ propertyName: "buttonContainer", first: true, predicate: ["buttonContainer"], descendants: true }], ngImport: i0, template: "<div [id]=\"buttonId\" #buttonContainer>\n    <!-- VituPay PayPal injected here -->\n</div>\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayPayPalElementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vitupay-paypal-element', template: "<div [id]=\"buttonId\" #buttonContainer>\n    <!-- VituPay PayPal injected here -->\n</div>\n" }]
        }], propDecorators: { config: [{
                type: Input
            }], clickValidator: [{
                type: Input
            }], onSubmitEvent: [{
                type: Output
            }], onSuccess: [{
                type: Output
            }], onError: [{
                type: Output
            }], buttonContainer: [{
                type: ViewChild,
                args: ["buttonContainer"]
            }] } });

class VituPayCardElementComponent {
    constructor() {
        this.clickValidator = () => { };
        this.onSubmitEvent = new EventEmitter();
        this.onInitEvent = new EventEmitter();
        this.onFormEmptyEvent = new EventEmitter();
        this.onFormValidityEvent = new EventEmitter();
        this.onResetEvent = new EventEmitter();
        this.onSuccess = new EventEmitter();
        this.onError = new EventEmitter();
        this.option = PaymentOptionDescriptor.Card;
    }
    submit() {
        if (this.paymentElement) {
            this.paymentElement.submit();
        }
    }
    reset() {
        if (this.paymentElement) {
            this.paymentElement.reset();
        }
    }
    focus() {
        if (this.paymentElement) {
            this.paymentElement.focus();
        }
    }
    ngOnInit() {
        this.elementId = `VITUPAY_${this.option}_${new Date().getTime()}`;
        this.paymentOptions = PaymentOptions.init([
            {
                descriptor: this.option
            }
        ]);
    }
    ngOnDestroy() {
        this.paymentElement?.remove();
    }
    ngAfterViewInit() {
        this.paymentOptions.add([ /* { descriptor: this.option } */], (paymentElements) => {
            this.paymentElement =
                paymentElements.add(this.option, `#${this.elementId}`, this.config, (events) => { this.successHandler(events); }, (error) => { this.onError.emit(error); }, this.clickValidator);
        }, (error) => { this.onError.emit(error); });
    }
    successHandler(events) {
        this.onSuccess.emit(events);
        this.events = events;
        this.events.listenSubmit((event) => {
            this.onSubmitEvent.emit(event);
        });
        this.events.listenInit((event) => {
            this.onInitEvent.emit(event);
        });
        this.events.listenFormEmpty((event) => {
            this.onFormEmptyEvent.emit(event);
        });
        this.events.listenFormValidity((event) => {
            this.onFormValidityEvent.emit(event);
        });
        this.events.listenReset((event) => {
            this.onResetEvent.emit(event);
        });
    }
}
VituPayCardElementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayCardElementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VituPayCardElementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VituPayCardElementComponent, selector: "vitupay-card-element", inputs: { config: "config", clickValidator: "clickValidator" }, outputs: { onSubmitEvent: "onSubmitEvent", onInitEvent: "onInitEvent", onFormEmptyEvent: "onFormEmptyEvent", onFormValidityEvent: "onFormValidityEvent", onResetEvent: "onResetEvent", onSuccess: "onSuccess", onError: "onError" }, viewQueries: [{ propertyName: "elementContainer", first: true, predicate: ["elementContainer"], descendants: true }], ngImport: i0, template: "<div [id]=\"elementId\" #elementContainer>\n    <!-- VituPay Card injected here -->\n</div>\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayCardElementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vitupay-card-element', template: "<div [id]=\"elementId\" #elementContainer>\n    <!-- VituPay Card injected here -->\n</div>\n" }]
        }], propDecorators: { config: [{
                type: Input
            }], clickValidator: [{
                type: Input
            }], onSubmitEvent: [{
                type: Output
            }], onInitEvent: [{
                type: Output
            }], onFormEmptyEvent: [{
                type: Output
            }], onFormValidityEvent: [{
                type: Output
            }], onResetEvent: [{
                type: Output
            }], onSuccess: [{
                type: Output
            }], onError: [{
                type: Output
            }], elementContainer: [{
                type: ViewChild,
                args: ["elementContainer"]
            }] } });

class VituPayModule {
}
VituPayModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VituPayModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VituPayModule, declarations: [VituPayGooglePayElementComponent,
        VituPayApplePayElementComponent,
        VituPayPayPalElementComponent,
        VituPayCardElementComponent], exports: [VituPayGooglePayElementComponent,
        VituPayApplePayElementComponent,
        VituPayPayPalElementComponent,
        VituPayCardElementComponent] });
VituPayModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VituPayModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        VituPayGooglePayElementComponent,
                        VituPayApplePayElementComponent,
                        VituPayPayPalElementComponent,
                        VituPayCardElementComponent
                    ],
                    imports: [],
                    exports: [
                        VituPayGooglePayElementComponent,
                        VituPayApplePayElementComponent,
                        VituPayPayPalElementComponent,
                        VituPayCardElementComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of vitupay
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VituPayApplePayElementComponent, VituPayCardElementComponent, VituPayGooglePayElementComponent, VituPayModule, VituPayPayPalElementComponent };
